import { render, staticRenderFns } from "./EditCandidate.vue?vue&type=template&id=ca5ceeca"
import script from "./EditCandidate.vue?vue&type=script&lang=js"
export * from "./EditCandidate.vue?vue&type=script&lang=js"
import style0 from "./EditCandidate.vue?vue&type=style&index=0&id=ca5ceeca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports